import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  container: {
    '& > :not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
  radioContainer: {
    marginTop: theme.spacing(3),
  },
  textWidth: {
    marginTop: theme.spacing(2),
    width: '485px',
  },
  subTerms: {
    paddingLeft: theme.spacing(3),
    marginTop: theme.spacing(2),
  },
  labelText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    fontFamily: theme.typography.fontFamily,
  },
  boxHeading: {
    fontSize: '16px !important',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    fontFamily: theme.typography.fontFamily,
  },
  radioLabel: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    fontFamily: theme.typography.fontFamily,
  },
  errorMessage: {
    color: theme.palette.error.dark,
    fontSize: '12px',
    marginTop: theme.spacing(1),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
  },
}))
